import React from "react";
import classnames from "classnames";
import logo from "assets/img/positron.png";

// reactstrap components
import { Navbar, Container } from "reactstrap";

function AuthNavbar(props) {
  return (
    <Navbar className={classnames("navbar-absolute fixed-top")} expand="lg">
      <Container>
        <div
          className="navbar-wrapper"
          style={{
            backgroundColor: "white",
            margin: "15px",
            padding: "10px 15px 10px 15px",
          }}
        >
          <img src={logo} />
        </div>
      </Container>
    </Navbar>
  );
}

export default AuthNavbar;
